module.exports = __webpack_public_path__ + "img/water-fall.2ab23cdc.svg";